import React from 'react';

/**
 * DataCanvas renders the image product plain and simple.
 * @reactProps {HTML Element} img - an img element we want to see
 */
export default class DataCanvas extends React.Component {
  render() {
    return <div className="data-canvas">{this.props.img}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/DataCanvas.js